import LogoHorizontal from "@images/logo_h.png";

export default {
  LogoHorizontal
};
